/* ============================================================
   BUFF X — Street & Loud  |  Shopify theme behavior
   Real cart via the Shopify AJAX API. Progressive enhancement.
   ============================================================ */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var routes = window.routes || { cart_add_url: '/cart/add', cart_change_url: '/cart/change', cart_url: '/cart' };
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function money(cents, currency) {
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD' }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }

  /* ---------- sticky nav ---------- */
  var nav = $('#SiteHeader');
  if (nav) {
    var onScroll = function () { nav.classList.toggle('stuck', window.scrollY > 8); };
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- mobile menu ---------- */
  var mm = $('#mobileMenu'), burger = $('#burger');
  function menu(open) {
    if (!mm) return;
    mm.classList.toggle('open', open);
    if (burger) burger.setAttribute('aria-expanded', String(open));
    document.body.style.overflow = open ? 'hidden' : '';
  }
  if (burger) burger.addEventListener('click', function () { menu(true); });
  var mc = $('#menuClose'); if (mc) mc.addEventListener('click', function () { menu(false); });
  if (mm) $$('a', mm).forEach(function (a) { a.addEventListener('click', function () { menu(false); }); });

  /* ---------- reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else { $$('.reveal').forEach(function (el) { el.classList.add('in'); }); }

  /* ---------- product gallery ---------- */
  var gmain = $('#galleryMain');
  if (gmain) {
    $$('.gthumb').forEach(function (t) {
      t.addEventListener('click', function () {
        $$('.gthumb').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        t.setAttribute('aria-pressed', 'true');
        var img = $('img', gmain);
        img.src = t.getAttribute('data-full');
        img.srcset = '';
        if (t.getAttribute('data-alt')) img.alt = t.getAttribute('data-alt');
      });
    });
  }

  /* ---------- variant / size selection ---------- */
  $$('.product-form').forEach(function (form) {
    var idInput = $('[name="id"]', form);
    var priceEl = $('.pprice-amount', form.closest('.pinfo') || document);
    var addBtn = $('[type="submit"]', form);
    var addLabel = addBtn ? addBtn.querySelector('.add-label') : null;
    $$('.size', form).forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.getAttribute('data-available') === 'false') { return; }
        $$('.size', form).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
        if (idInput) idInput.value = b.getAttribute('data-variant-id');
        if (priceEl && b.getAttribute('data-price')) priceEl.textContent = b.getAttribute('data-price');
        var hint = $('#sizeHint', form); if (hint) hint.textContent = 'Size: ' + b.textContent.trim();
        if (addBtn) addBtn.disabled = false;
      });
    });
  });

  /* ============================================================
     CART (Shopify AJAX API)
     ============================================================ */
  function getCart() { return fetch(routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }

  function paintCart(cart) {
    $$('.cart-count').forEach(function (el) {
      el.textContent = cart.item_count;
      el.setAttribute('data-empty', String(cart.item_count === 0));
    });
    var body = $('#drawerBody'), foot = $('#drawerFoot');
    if (!body) return;
    if (!cart.items || !cart.items.length) {
      body.innerHTML = '<div class="drawer-empty">Your bag is empty.<br>Time to hit the drop.</div>';
      if (foot) foot.style.display = 'none';
      return;
    }
    if (foot) foot.style.display = '';
    body.innerHTML = cart.items.map(function (i) {
      var img = i.image ? i.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_120x$1') : '';
      var variant = (i.variant_title && i.variant_title !== 'Default Title') ? i.variant_title + ' · ' : '';
      return '<div class="line-item" data-key="' + i.key + '">' +
        (img ? '<img src="' + img + '" alt="' + (i.product_title || '') + '" loading="lazy">' : '') +
        '<div><div class="li-t">' + i.product_title + '</div><div class="li-m">' + variant + 'Qty ' + i.quantity + '</div></div>' +
        '<span class="li-p">' + money(i.final_line_price, cart.currency) + '</span>' +
        '<button class="li-x" data-remove="' + i.key + '" aria-label="Remove ' + i.product_title + '">&times;</button>' +
        '</div>';
    }).join('');
    var sub = $('#subtotalVal'); if (sub) sub.textContent = money(cart.total_price, cart.currency);
    $$('[data-remove]', body).forEach(function (b) {
      b.addEventListener('click', function () { changeLine(b.getAttribute('data-remove'), 0); });
    });
  }

  function refreshCart(open) {
    return getCart().then(function (cart) { paintCart(cart); if (open) drawer(true); return cart; });
  }

  function changeLine(key, qty) {
    return fetch(routes.cart_change_url + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (cart) { paintCart(cart); return cart; });
  }

  function addToCart(id, qty, btn) {
    if (btn) { btn.classList.add('loading'); btn.disabled = true; }
    return fetch(routes.cart_add_url + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw e; });
      return r.json();
    }).then(function () {
      toast('Added to bag ✓', true);
      if (window.cartType === 'page') { window.location = routes.cart_url; return; }
      return refreshCart(true);
    }).catch(function (err) {
      toast((err && err.description) || 'Could not add to bag', false);
    }).then(function () {
      if (btn) { btn.classList.remove('loading'); btn.disabled = false; }
    });
  }

  /* intercept product form submits */
  $$('.product-form').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var sizes = $$('.size', form);
      var chosen = $('.size[aria-pressed="true"]', form);
      if (sizes.length && !chosen) { e.preventDefault(); toast('Pick a size first', false); var h = $('#sizeHint', form); if (h) h.style.color = 'var(--blue-glow)'; return; }
      e.preventDefault();
      var idInput = $('[name="id"]', form);
      var qtyInput = $('[name="quantity"]', form);
      addToCart(idInput.value, qtyInput ? parseInt(qtyInput.value, 10) : 1, $('[type="submit"]', form));
    });
  });

  /* ---------- cart drawer ---------- */
  var dEl = $('#drawer'), scrim = $('#drawerScrim');
  function drawer(open) {
    if (!dEl) return;
    dEl.classList.toggle('open', open);
    if (scrim) scrim.classList.toggle('open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  }
  $$('.cart-btn').forEach(function (b) {
    b.addEventListener('click', function (e) {
      if (window.cartType === 'page') return; // let it navigate
      e.preventDefault(); refreshCart(true);
    });
  });
  var dc = $('#drawerClose'); if (dc) dc.addEventListener('click', function () { drawer(false); });
  if (scrim) scrim.addEventListener('click', function () { drawer(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { drawer(false); menu(false); } });

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg, good) {
    var t = $('#toast'); if (!t) return;
    $('#toastMsg', t).textContent = msg;
    var icon = t.querySelector('svg'); if (icon) icon.style.display = good ? '' : 'none';
    t.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('show'); }, 2600);
  }

  /* keep the header badge in sync on load */
  getCart().then(paintCart).catch(function () {});
})();
